import { Divider, Grid, Icon } from 'semantic-ui-react';
import StageAssigneeTable from './StageAssigneeTable';
import TasksTable from './TasksTable';
import AttachmentsTable from './AttachmentsTable';
import React, { useState } from 'react';
import CustomField from './CustomField';
import { FormattedMessage } from 'react-intl';

const prefix = 'issueDetails';

export function IssueDetails({ issueDetails }) {
  const name = issueDetails?.name;
  const due_date = issueDetails?.due_date;
  const assignee = issueDetails?.project_assignee;
  const tasks = issueDetails?.tasks;
  const attachments = issueDetails?.attachments;
  const [showSection, setShowSection] = useState(false);

  const toggleSection = () => {
    setShowSection(!showSection);
  };
  return (
    <span className="issue-details">
      {showSection ? (
        <div className="section-header" onClick={toggleSection}>
          <Icon name="chevron up" inline="true" data-testid="chevron-up-icon" />
          <FormattedMessage id="common.details" defaultMessage="Details" />
        </div>
      ) : (
        <div className="section-header" onClick={toggleSection}>
          <Icon name="chevron down" inline="true" data-testid="chevron-down-icon" />
          <FormattedMessage id="common.details" defaultMessage="Details" />
        </div>
      )}
      {showSection && (
        <div className="section-body">
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={8} className="custom-field-label">
                <FormattedMessage id={`${prefix}.shortDescription`} defaultMessage="Title / Short Description" />
              </Grid.Column>
              <span className="title">
                <CustomField value={name} type="text" />
              </span>
              <Grid.Column width={8} className="custom-field-label">
                <FormattedMessage id={`${prefix}.projectDueDate`} defaultMessage="Project Due Date" />
              </Grid.Column>
              <span className="project-due-date">
                <CustomField value={due_date} type="date" />
              </span>
            </Grid.Row>
          </Grid>
          <StageAssigneeTable stageAssignees={assignee} />
          <TasksTable tasks={tasks} isIssueDetail={true} />
          <AttachmentsTable attachments={attachments} />
        </div>
      )}
      <Divider> </Divider>
    </span>
  );
}
